import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import Translator from "../../Translation/Translator";
import Http from "../../Http/Http";

export default function* personDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PERSON_DELETE_REQUEST
    });

    yield call(Http.delete, `contact/${action.payload?.person.id}`);

    const person: PersonInterface = action.payload?.person.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_PERSON_DELETE_SUCCESS,
      payload: {
        person: person
      }
    });

    // show snackbar
    if (person?.isUser() || person?.isAdmin()) {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-user-removed-successfully"),
          type: "success"
        }
      });
    } else {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans(`snackbar-message-person-removed-successfully`),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, person);
    }

    yield put({
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: 0
      }
    });

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PERSON_DELETE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchPersonDelete() {
  yield takeEvery(Constants.GLOBAL_PERSON_DELETE_START, personDelete);
}
